export default __webpack_public_path__ + "static/media/xmark-solid.d76b0940.svg";